import React from "react";

export const CheckBox = (props) => {
  return (
    <div class="custom-control custom-checkbox">
      <input
        type="checkbox"
        class="custom-control-input"
        id={props.id}
        key={props.id}
        onClick={props.handleCheckChieldElement}
        checked={props.isChecked}
        value={props.value}
        disabled={props.disabled}
      />
      <label class="custom-control-label" for={props.id}>
        {props.value === "HO"
          ? "Hydrological Observation Stations"
          : props.value}
      </label>
    </div>
  );
};

export default CheckBox;
